import { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      setFormData({ name: '', phone: '', message: '' });
    }, 3000);
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24">
        <section className="relative py-20 bg-gradient-to-br from-primary to-secondary text-white overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 right-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 left-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
          </div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center animate-fade-in">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">تواصل معنا</h1>
              <p className="text-xl md:text-2xl text-white/90 leading-relaxed">
                نحن هنا <strong>لمساعدتك في أي وقت</strong>
              </p>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-12">
                <div className="animate-slide-up">
                  <h2 className="text-3xl font-bold text-primary mb-6">أرسل لنا رسالة</h2>
                  
                  {showSuccess && (
                    <div className="bg-primary/10 border-2 border-primary rounded-lg p-4 mb-6 animate-fade-in">
                      <div className="flex items-center gap-3">
                        <i className="ri-checkbox-circle-line text-primary text-2xl"></i>
                        <p className="text-primary font-medium">تم إرسال رسالتك بنجاح! سنتواصل معك قريباً</p>
                      </div>
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                      <label className="block text-gray-700 font-medium mb-2">
                        <i className="ri-user-line ml-2"></i>
                        الاسم *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-primary focus:outline-none transition-colors text-lg"
                        placeholder="أدخل اسمك"
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-medium mb-2">
                        <i className="ri-phone-line ml-2"></i>
                        رقم الجوال *
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-primary focus:outline-none transition-colors text-lg"
                        placeholder="05xxxxxxxx"
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-medium mb-2">
                        <i className="ri-message-3-line ml-2"></i>
                        الرسالة *
                      </label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        rows={6}
                        maxLength={500}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-primary focus:outline-none transition-colors text-lg resize-none"
                        placeholder="اكتب رسالتك هنا..."
                      ></textarea>
                      <p className="text-sm text-gray-500 mt-2">الحد الأقصى 500 حرف</p>
                    </div>

                    <button
                      type="submit"
                      className="w-full inline-flex items-center justify-center gap-2 bg-primary text-white px-8 py-4 rounded-lg font-medium hover:bg-primary-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-send-plane-line"></i>
                      <span>إرسال الرسالة</span>
                    </button>
                  </form>
                </div>

                <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
                  <h2 className="text-3xl font-bold text-primary mb-6">معلومات التواصل</h2>
                  
                  <div className="space-y-6 mb-8">
                    <div className="flex items-start gap-4 p-6 bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl hover:shadow-lg transition-shadow duration-300">
                      <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-phone-line text-white text-2xl"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">الهاتف</h3>
                        <a href="tel:+966500000000" className="text-gray-600 hover:text-primary transition-colors cursor-pointer">
                          +966 50 000 0000
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start gap-4 p-6 bg-gradient-to-br from-secondary/5 to-accent/5 rounded-xl hover:shadow-lg transition-shadow duration-300">
                      <div className="w-12 h-12 bg-secondary rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-white text-2xl"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">البريد الإلكتروني</h3>
                        <a href="mailto:info@quit-clinic.sa" className="text-gray-600 hover:text-secondary transition-colors cursor-pointer">
                          info@quit-clinic.sa
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start gap-4 p-6 bg-gradient-to-br from-accent/5 to-primary/5 rounded-xl hover:shadow-lg transition-shadow duration-300">
                      <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-white text-2xl"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">العنوان</h3>
                        <p className="text-gray-600">الأفلاج، المملكة العربية السعودية</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4 p-6 bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl hover:shadow-lg transition-shadow duration-300">
                      <div className="w-12 h-12 bg-primary-600 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-whatsapp-line text-white text-2xl"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">واتساب</h3>
                        <a 
                          href="https://wa.me/966500000000" 
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-2 text-primary-600 hover:text-primary transition-colors cursor-pointer"
                        >
                          <span>تواصل عبر واتساب</span>
                          <i className="ri-arrow-left-line"></i>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-4">تابعنا على</h3>
                    <div className="flex gap-3">
                      <a
                        href="https://wa.me/966500000000"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="w-12 h-12 bg-primary/10 hover:bg-primary text-primary hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
                      >
                        <i className="ri-whatsapp-line text-xl"></i>
                      </a>
                      <a
                        href="https://twitter.com"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="w-12 h-12 bg-secondary/10 hover:bg-secondary text-secondary hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
                      >
                        <i className="ri-twitter-x-line text-xl"></i>
                      </a>
                      <a
                        href="https://instagram.com"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="w-12 h-12 bg-accent/10 hover:bg-accent text-accent hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
                      >
                        <i className="ri-instagram-line text-xl"></i>
                      </a>
                      <a
                        href="https://facebook.com"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="w-12 h-12 bg-primary-600/10 hover:bg-primary-600 text-primary-600 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
                      >
                        <i className="ri-facebook-fill text-xl"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-12 animate-fade-in">
                <h2 className="text-4xl font-bold text-primary mb-4">موقعنا</h2>
                <p className="text-xl text-gray-600">
                  يمكنك زيارتنا في <strong>الأفلاج</strong>
                </p>
              </div>

              <div className="rounded-2xl overflow-hidden shadow-2xl animate-slide-up">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d233667.82239586756!2d46.51670000000001!3d22.083300000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03f7e8d3c3c3%3A0x3e2f03f7e8d3c3c3!2sAl%20Aflaj!5e0!3m2!1sen!2ssa!4v1234567890123!5m2!1sen!2ssa"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="موقع عيادة الإقلاع"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-gradient-to-br from-primary to-secondary text-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center animate-fade-in">
              <h2 className="text-4xl md:text-5xl font-bold mb-6">هل تحتاج مساعدة فورية؟</h2>
              <p className="text-xl text-white/90 mb-8 leading-relaxed">
                تواصل معنا الآن عبر <strong>الواتساب</strong> للحصول على استشارة سريعة
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://wa.me/966500000000"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-white text-primary px-8 py-4 rounded-lg font-medium hover:bg-white/90 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  <span>تواصل عبر واتساب</span>
                </a>
                <a
                  href="tel:+966500000000"
                  className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-lg font-medium hover:bg-white hover:text-primary transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span>اتصل بنا</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}